import { CloseOutlined } from '@ant-design/icons'
import { Button, Form, /* Input, */ Modal, Select } from 'antd'
import { useForm } from 'antd/es/form/Form'
import dayjs from 'dayjs'
import { FC, useEffect, useState } from 'react'
import useErrorModal from '../../../../../hooks/api/use-error-modal'
import { userStorage } from '../../../../../services/user-storage'
import { useUpdatePrintJobExecutorMutation } from '../../../../../store/api/print-job-executors-api'
import { useUpdatePrintJobMutation } from '../../../../../store/api/print-jobs-api'
import { printQueueEntriesApi } from '../../../../../store/api/print-queue-entries-api'
import { useAppDispatch } from '../../../../../store/store'
import { CancelationReasons, JobStatuses } from '../../../../../types/api/print-job'
import { Reasons } from '../../../../../types/api/print-job-executor'
import PrintQueueEntry from '../../../../../types/api/print-queue-entry'
import {
    getCurrentUserActiveExecutor,
    isCurrentUserActiveExecutor,
} from '../helpers/print-job-helpers'

interface FormValues {
    cancelationReason: CancelationReasons
    // otherCancelationReason?: string
}

interface CancelPrintProps {
    printQueueEntry: PrintQueueEntry
}

const CancelPrint: FC<CancelPrintProps> = ({ printQueueEntry }) => {
    const [open, setOpen] = useState<boolean>(false)
    const [form] = useForm<FormValues>()
    const [updatePrintJob, updatePrintJobState] = useUpdatePrintJobMutation()
    // const [deletePrintQueueEntry, deletePrintQueueEntryState] = useDeletePrintQueueEntryMutation()
    const [updatePrintJobExecutor, updatePrintJobExecutorState] =
        useUpdatePrintJobExecutorMutation()
    const printJob = printQueueEntry.print_job
    const currentUserDocumentId = userStorage.get()?.documentId
    const disabled = !isCurrentUserActiveExecutor(printJob, currentUserDocumentId)
    const isLoadingAnyRequest =
        updatePrintJobExecutorState.isLoading || updatePrintJobState.isLoading
    // deletePrintQueueEntryState.isLoading

    const dispatch = useAppDispatch()

    const onUpdatePrintJobExecutor = async () => {
        const executor = getCurrentUserActiveExecutor(printJob, currentUserDocumentId)

        if (!executor) return

        return updatePrintJobExecutor({
            docId: executor.documentId,
            body: {
                data: {
                    end: dayjs().toISOString(),
                    reason: Reasons.Cancel,
                },
            },
        })
    }

    const onConfirm = async () => {
        try {
            // TODO: при отмене печати в одной очереди автоматически отменяются остальные?
            await form.validateFields()
            const values = form.getFieldsValue()
            const result = await onUpdatePrintJobExecutor()

            if (result && result.data) {
                await updatePrintJob({
                    docId: printQueueEntry.print_job?.documentId!,
                    body: {
                        data: {
                            jobStatus: JobStatuses.Cancelled, // TODO: рубим всю цепочку, это нормально?
                            cancelationReason: values.cancelationReason,
                            // otherCancelationReason:
                            //     values.cancelationReason === CancelationReasons.Other
                            //         ? values.otherCancelationReason
                            //         : undefined,
                        },
                    },
                })

                // if (updateResult.data) {
                //     await deletePrintQueueEntry(printQueueEntry.documentId)
                // }
            }
        } catch (e) {
            console.error(e)
        }
    }

    const onCancel = () => {
        form.setFieldsValue({ cancelationReason: CancelationReasons.Other })
        setOpen(true)
    }

    useEffect(() => {
        if (updatePrintJobExecutorState.isSuccess) {
            dispatch(printQueueEntriesApi.util.invalidateTags(['PrintQueueEntries']))
            setOpen(false)
        }
    }, [updatePrintJobExecutorState.isSuccess, dispatch])

    // useEffect(() => {
    //     if (deletePrintQueueEntryState.isSuccess || updatePrintJobExecutorState.isSuccess) {
    //         dispatch(printQueueEntriesApi.util.invalidateTags(['PrintQueueEntries']))
    //         setOpen(false)
    //     }
    // }, [deletePrintQueueEntryState.isSuccess, updatePrintJobExecutorState.isSuccess, dispatch])

    useErrorModal(updatePrintJobExecutorState, 'Ошибка обновления исполнителя задания')
    // useErrorModal(deletePrintQueueEntryState, 'Ошибка удаления задания из очереди')
    useErrorModal(updatePrintJobState, 'Ошибка обновления задания печати')

    return (
        <>
            <Button icon={<CloseOutlined />} onClick={onCancel} disabled={disabled} danger>
                Отменить
            </Button>
            <Modal
                title={'Отмена печати'}
                open={open}
                onOk={onConfirm}
                confirmLoading={isLoadingAnyRequest}
                cancelButtonProps={{ disabled: isLoadingAnyRequest }}
                onCancel={() => setOpen(false)}
            >
                <Form
                    form={form}
                    initialValues={{ cancelationReason: CancelationReasons.Other }}
                >
                    <Form.Item
                        name={'cancelationReason'}
                        label={'Причина отмены'}
                        rules={[{ required: true }]}
                    >
                        <Select options={[{ value: CancelationReasons.Other }]} />
                    </Form.Item>
                    {/* <Form.Item
                        shouldUpdate={(prev: FormValues, next: FormValues) =>
                            prev.cancelationReason !== next.cancelationReason
                        }
                    >
                        {form => {
                            const { cancelationReason } = form.getFieldsValue()

                            if (cancelationReason === CancelationReasons.Other) {
                                return (
                                    <Form.Item
                                        name={'otherCancelationReason'}
                                        label={'Опишите причину'}
                                        rules={[{ required: true }]}
                                    >
                                        <Input.TextArea />
                                    </Form.Item>
                                )
                            }

                            return null
                        }}
                    </Form.Item> */}
                </Form>
            </Modal>
        </>
    )
}

export default CancelPrint
